import React from 'react';
import classes from './Modal.module.css';
import closeIcon from '../../../assets/icons/close.svg';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  containerPadding?: string;
  children: any;
  width?: string;
  maxWidth?: string;
  hideCloseButton?: boolean;
  header?: React.ReactNode;
  divider?: boolean;
  headerStyles?: React.CSSProperties;
  closeButtonStyles?: React.CSSProperties;
};

const Modal: React.FC<Props> = ({
  isOpen,
  onClose,
  containerPadding,
  children,
  width,
  hideCloseButton,
  maxWidth,
  header,
  divider,
  headerStyles = {},
  closeButtonStyles = {},
}) => {
  return (
    <div className={classes.root} style={{ display: isOpen ? 'flex' : 'none' }}>
      <div className={classes.backdrop} onClick={onClose} />
      <div
        className={classes.container}
        style={{ padding: containerPadding, width: width, maxWidth: maxWidth }}
      >
        <div
          className={classes.headerContainer}
          style={{ ...headerStyles, borderBottom: divider ? '1px solid #dbdfea' : 'none' }}
        >
          <div className={classes.header}>{header}</div>
          {!hideCloseButton && (
            <img
              className={classes.closeButton}
              style={{ ...closeButtonStyles }}
              src={closeIcon}
              alt="closeIcon"
              onClick={onClose}
            />
          )}
        </div>
        {/*{divider && <div className={classes.horizontalDivider} />}*/}
        {children}
      </div>
    </div>
  );
};

export default Modal;
